module.exports = __webpack_public_path__ + "static/media/GothamBold.46e967b8.ttf";